import { useState, useEffect } from 'react';
import { advisorService } from '../services/apiService';
import AdvisorList from '../components/AdvisorList';

const Advisors = () => {
  const [advisors, setAdvisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchAdvisors = async () => {
    try {
      setLoading(true);
      const data = await advisorService.getAllAdvisors();
      setAdvisors(data);
    } catch (err) {
      setError(err.message || 'Failed to fetch advisors');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdvisors();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading advisors...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Global Advisors Management</h2>
      <AdvisorList advisors={advisors} fetchAdvisors={fetchAdvisors} />
    </div>
  );
};

export default Advisors;
